import { useCallback } from 'react';
import { VoiceInterface } from '@frontend/ai-receptionist-ui';
import { getWeaveToken } from '@frontend/auth-helpers';
import { getInitialParams } from '@frontend/env';
import { http } from '@frontend/fetch';
import { useTranslation } from '@frontend/i18n';
import { useChannelSubscription } from '@frontend/queue';
import { useAppScopeStore } from '@frontend/scope';
import {
  GlobalSettingsPanelEntry,
  SettingsPanelHeader,
  SettingsPanelContent,
  useGlobalSettingsPanel,
} from '@frontend/settings-panel-engine';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const AiReceptionistGlobalPanel = () => {
  const { open, close } = useGlobalSettingsPanel('ai-receptionist-test-panel');
  const { t } = useTranslation('ai-receptionist');
  const token = getWeaveToken();
  const { selectedLocationIds } = useAppScopeStore();
  const locationId = selectedLocationIds[0];
  const currentBaseUrl = http.baseUrl || getInitialParams().backendApi;
  const isDev = currentBaseUrl?.includes('api.weavedev.net');

  const wsUrl =
    token && locationId && isDev
      ? `wss://api.weavedev.net/v1/va-reverse-proxy/ws/connect?location_id=${locationId}&token=${token}`
      : '';

  // Subscribe to AI receptionist events
  const eventHandler = useCallback(
    (event: any) => {
      if (event.payload?.action === 'open') {
        open();
        return true;
      }
      if (event.payload?.action === 'close') {
        close();
        return true;
      }
      return false;
    },
    [open, close]
  );

  useChannelSubscription('ai-receptionist-test-panel', eventHandler);

  if (!wsUrl) {
    return null;
  }

  return (
    <GlobalSettingsPanelEntry id='ai-receptionist-test-panel' width='medium'>
      <SettingsPanelHeader>
        <SettingsPanelHeader.Title>{t('Test AI Receptionist')}</SettingsPanelHeader.Title>
        <SettingsPanelHeader.Close />
      </SettingsPanelHeader>
      <Text color='subdued' css={{ padding: `0 ${theme.spacing(4)}` }}>
        {t(
          'This is a simulated phone call with the AI Receptionist. No real phone calls are being placed by your office.'
        )}
      </Text>
      <SettingsPanelContent css={{ height: '100%' }}>
        <VoiceInterface wsUrl={wsUrl} />
      </SettingsPanelContent>
    </GlobalSettingsPanelEntry>
  );
};
